<template>
  <div class="layer-category">
    <div class="layer-category__header" @click="drawerOpen = !drawerOpen">
      <i class="fas" :class="icon" style="padding-right: 10px;" />
      <span class="layer-category__header__label">{{ label }}</span>
      <i
        class="fas"
        :class="{
          'fa-caret-up': drawerOpen,
          'fa-caret-down': !drawerOpen
        }"
        style="margin-left: auto; order: 2;"
      />
    </div>
    <div
      v-show="drawerOpen"
      class="layer-category__content"
      style="margin: 10px;"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'drawer label'
    },
    icon: {
      type: String,
      default: 'fa-building'
    },
    category: {
      type: Object,
      default: () => ({
        id: 'cat-id',
        label: 'cat label',
        icon: 'cat-icon'
      })
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawerOpen: this.open
    }
  },
  watch: {
    drawerOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('update:open', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer-category {
  &__header {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 7px;
    border-bottom: 2px solid #dddddd;
    &-label {
      padding-left: 5px;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.fas {
  color: #ddd;
}
</style>
